export type SearchTab = 'brand' | 'branch' | 'item';

export const searchTabs: { label: string; value: SearchTab }[] = [
  {
    label: 'Brand',
    value: 'brand',
  },
  {
    label: 'Branch',
    value: 'branch',
  },
  {
    label: 'Item',
    value: 'item',
  },
];
